// extracted by mini-css-extract-plugin
export default {"placeholder":"OxjMSXIl","dropdownStyle":"jS8JUsG_","MuiList-root":"Wrrb1J9A","MuiMenuItem-root":"Pq_3QZHK","MuiPopover-paper":"ZDwMpC3j"};